import React from 'react';
import styled from 'styled-components';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

const StyledWrap = styled.div`
  padding: 7em 0;

  @media screen and (max-width: 768px){
    padding: 4em 0;
  }
`;

export default function renderContainer(
  Container,
  store,
  router,
  elementId,
  ownProps,
  isLandingPage,
) {
  const StyledContainer = isLandingPage ? (<Container router={router} {...ownProps} />)
    : (
      <StyledWrap className="container">
        <Container router={router} {...ownProps} />
      </StyledWrap>
    );

  render(
    /* NOTE: Most pages built earlier than pixel-perfect is
      designed based on boostrap's responsive "container" style.
      However, the landing page in pixel-perfect need full-width background,
      which cannot use "container".
      Thus, we decide to assign containers other than landing pages the "container" style.
    */
    <Provider store={store}>
      {StyledContainer}
    </Provider>,
    document.getElementById(elementId)
  );
}



// WEBPACK FOOTER //
// ./src/toolbox/renderContainer.js